export default __webpack_public_path__ + "static/media/book-store-1.da48d582.PNG";